// extracted by mini-css-extract-plugin
export default {"list":"_","link":"aa","isDark":"ba","icon":"ca","blinking":"da","gradientShift":"ea","float":"fa","move":"ga","scroll":"ha"};